import { render, staticRenderFns } from "./gift-cell.vue?vue&type=template&id=51bc2f89&scoped=true&"
import script from "./gift-cell.vue?vue&type=script&lang=js&"
export * from "./gift-cell.vue?vue&type=script&lang=js&"
import style0 from "./gift-cell.vue?vue&type=style&index=0&id=51bc2f89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc2f89",
  null
  
)

export default component.exports